import(/* webpackMode: "eager" */ "/app/src/app/page.jsx");
